import { Avatar } from 'components/Avatar';
import { FC } from 'react';
import { addSpaceNumber } from 'utils/addSpaceNumber';
import styles from './CheckItem.module.scss';
import { CheckItemType } from 'redux/Api/checksApi/type';

interface CheckItemTypes {
  check: CheckItemType;
}

export const CheckItem: FC<CheckItemTypes> = ({ check }) => {
  return (
    <div className={styles.root}>
      <p className={styles.root_item__standart}>{check.id}</p>
      <div className={styles.root_item} style={{ display: 'inline-flex' }}>
        <p>{check.receipt_date}</p>
      </div>
      <p className={styles.root_item__standart}>{check.order_data.type}</p>
      <div className={styles.root_item__avatar}>
        <Avatar
          height='24px'
          width='24px'
          avatar={null}
          statusActive={''}
          id={0}
          name={check.worker_data.fio}
        />
        <span>{check.worker_data.fio}</span>
      </div>
      <p className={styles.root_item__standart} style={{ textAlign: 'end' }}>
        {addSpaceNumber(check.order_data.amount)}
      </p>

      <p
        className={`${styles.root_item__standart} ${
          check.upload_status
            ? styles.root_item__status_registered
            : styles.root_item__status_unregistered
        }`}>
        {check.upload_status ? 'Зарегистрирован' : 'Не зарегистрирован'}
      </p>
    </div>
  );
};
